export const SET_POSITION_LIST = 'SET_POSITION_LIST'
export const SET_SELECTED_POSITION = 'SET_SELECTED_POSITION'
export const SET_SELECTED_POSITION_NAME = 'SET_SELECTED_POSITION_NAME'
export const SET_ABILITY_ADD_DRIVER = 'SET_ABILITY_ADD_DRIVER'
export const SET_ABILITY_EDIT_DRIVER = 'SET_ABILITY_EDIT_DRIVER'
export const SET_ABILITY_DRIVER_SERVICE = 'SET_ABILITY_DRIVER_SERVICE'
export const SET_ABILITY_DRIVER_MONITOR = 'SET_ABILITY_DRIVER_MONITOR'
export const SET_ABILITY_DRIVER_TRAJECTORY = 'SET_ABILITY_DRIVER_TRAJECTORY'
export const SET_ABILITY_DRIVER_MESSAGE = 'SET_ABILITY_DRIVER_MESSAGE'
export const SET_ABILITY_TRANSACTION = 'SET_ABILITY_TRANSACTION'
export const SET_ABILITY_TRANSACTION_STATISTICS =
  'SET_ABILITY_TRANSACTION_STATISTICS'
export const SET_ABILITY_CUSTOMER = 'SET_ABILITY_CUSTOMER'
export const SET_ABILITY_STORE = 'SET_ABILITY_STORE'
export const SET_ABILITY_LANDMARK = 'SET_ABILITY_LANDMARK'
export const SET_ABILITY_RESERVATION = 'SET_ABILITY_RESERVATION'
export const SET_ABILITY_DISPATCH_AREA = 'SET_ABILITY_DISPATCH_AREA'
export const SET_ABILITY_SCHEDULED_AREA = 'SET_ABILITY_SCHEDULED_AREA'
export const SET_ABILITY_SCHEDULED_BOARD = 'SET_ABILITY_SCHEDULED_BOARD'
export const SET_ABILITY_MOBILE_PAYMENT = 'SET_ABILITY_MOBILE_PAYMENT'
export const SET_ABILITY_USER_MANAGEMENT = 'SET_ABILITY_USER_MANAGEMENT'
export const SET_ABILITY_USER_BEHAVIOR = 'SET_ABILITY_USER_BEHAVIOR'
export const SET_ABILITY_POSITION_MANAGEMENT = 'SET_ABILITY_POSITION_MANAGEMENT'
export const SET_ABILITY_TRANSACTION_RECORD = 'SET_ABILITY_TRANSACTION_RECORD'
export const SET_ABILITY_CALL_CAR = 'SET_ABILITY_CALL_CAR'
export const SET_ABILITY_SAVE_HAIL_BILL = 'SET_ABILITY_SAVE_HAIL_BILL'
export const SET_ABILITY_SAVE_RESERVATION = 'SET_ABILITY_SAVE_RESERVATION'
export const SET_ABILITY_ANNOUNCEMENT = 'SET_ABILITY_ANNOUNCEMENT'
export const SET_ABILITY_USER_DELETION = 'SET_ABILITY_USER_DELETION'



// WEBPACK FOOTER //
// ./src/store/positionStore/mutation-types.js